require('./bootstrap');

window.$ = window.jQuery = require('jquery');

var j = 'jQuery';// Burla o webpack para expor o jQuery
window[j] = window.$ = require('jquery');
// require('./helpers/data-collapse'); // Corrige os data targets do collapse
require('./helpers/campo-senha-visualizar');

var requireRegister = require('./requireRegister');
require('bootstrap/dist/js/bootstrap');
requireRegister($,
    '.r-acionamento.c-acionamento.a-index',
    require('./mvc/routes/acionamento')
);

requireRegister($,
    '.l-layout',
    require('./mvc/layouts/layout')
);

requireRegister($,
    '.r-meus-acionamentos',
    require('./mvc/routes/meus-acionamentos')
);

//ADMIN ROUTES
requireRegister($,
    '.r-todos-acionamentos',
    require('./mvc/routes/admin/todos-acionamentos')
);
requireRegister($,
    '.r-todos-clientes',
    require('./mvc/routes/admin/todos-clientes')
);
